import { createCandyUITest } from "@kontur.candy/form-testing";
import { expect } from "@playwright/test";

const test = createCandyUITest({ gfv: "{gfv}" });

test.describe("DemoTest", () => {
    test("Авторасчет значения", async ({ form }) => {
        await form.setValueToControl("Файл/Документ/Значениe1", "setValue", "10")
        expect(await form.getValueFromControl("Файл/Документ/Значениe2", "getValue")).toBe("9")
        expect(await form.getValueFromControl("Файл/Документ/Значениe3", "getValue")).toBe("12")
    });
});
